// // // ApDebitMemoApplication.tsx
// // import React, { useState, useEffect } from 'react';
// // import { useTranslation } from 'react-i18next';
// // import { Form, Table, Button, Badge, Alert } from 'react-bootstrap';
// // import type { FormikProps } from 'formik';
// // import Loading from '@components/Shared/Loader/Loading';
// // import { type UnPaymentSchedulesModels } from '@store/Finance/AP/ApInvoices/ApInvoicesModels';
// // import { fetchUnpaidInvoices } from '@store/Finance/AP/ApInvoices/UnpaidInvoicesSlice';
// // import { useAppDispatch } from '@store/hooks';

// // // أنواع البيانات
// // interface OutstandingInvoice {
// //   id: string;
// //   invoiceNumber: string;
// //   invoiceDate: string;
// //   totalAmount: number;
// //   remainingBalance: number;
// //   currencyCode: string;
// //   description?: string;
// //   supplierName?: string;
// // }

// // interface AppliedInvoice {
// //   invoiceId: string;
// //   invoiceNumber: string;
// //   appliedAmount: number;
// //   remainingBalance: number;
// //   currencyCode: string;
// // }

// // interface FormValues {
// //   invoiceNum: string;
// //   peopleId: string;
// //   invoiceType: string;
// //   referenceType: string;
// //   referenceId: string;
// //   invoiceDate: string;
// //   organizationId: string;
// //   paymentTermsId: string;
// //   paymentMethodId: string;
// //   currencyCode: string;
// //   currencyConversionRate: number;
// //   includeVatFlag: boolean;
// //   apInvoiceLinesList: any[];
// //   apPaymentSchedulesList: any[];
// //   appliedToInvoiceId: string;
// //   appliedAmount: number;
// //   appliedInvoices?: AppliedInvoice[];
// // }

// // interface ApDebitMemoApplicationProps {
// //   formik: FormikProps<FormValues>;
// //   outstandingInvoices?: OutstandingInvoice[];
// //   loading?: boolean;
// //   error?: string | null;
// // }

// // const ApDebitMemoApplication: React.FC<ApDebitMemoApplicationProps> = ({
// //   formik,
// //   outstandingInvoices,
// //   loading = false,
// //   error = null
// // }) => {
// //   const { values } = formik;
// //   const dispatch = useAppDispatch();

// //   const [invoices, setInvoices] = useState<UnPaymentSchedulesModels[]>([]);
// //   const [isLoading, setIsLoading] = useState(false);
// //   const [fetchError, setFetchError] = useState<string | null>(null);

// //   const { t } = useTranslation();

// //   const handleGetUnpaidInvoices = async () => {
// //     if (!values.organizationId || !values.peopleId) return;

// //     setIsLoading(true);
// //     setFetchError(null);

// //     try {
// //       const data = await dispatch(
// //         fetchUnpaidInvoices({
// //           peopleId: values.peopleId,
// //           organizationId: values.organizationId,
// //           invoiceType: 'Standard'
// //         })
// //       ).unwrap();
// //       if (data.succeeded) {
// //         setInvoices(data.data);
// //         if (data.data.length === 0) {
// //           setFetchError('لم يتم العثور على فواتير');
// //         }
// //       } else {
// //         setFetchError('فشل في جلب الفواتير');
// //       }
// //     } catch (error) {
// //       console.error('Error fetching unpaid invoices:', error);
// //       setFetchError('فشل في جلب الفواتير');
// //     } finally {
// //       setIsLoading(false);
// //     }
// //   };
// //   console.log(JSON.stringify(invoices));

// //   useEffect(() => {
// //     handleGetUnpaidInvoices();
// //   }, []);

// //   // بيانات ثابتة للفواتير المعلقة
// //   const staticOutstandingInvoices: OutstandingInvoice[] = [
// //     {
// //       id: '1',
// //       invoiceNumber: 'INV-2023-001',
// //       invoiceDate: '2023-10-15',
// //       totalAmount: 5000,
// //       remainingBalance: 3000,
// //       currencyCode: 'SAR',
// //       description: 'فاتورة مواد مكتبية - أكتوبر 2023',
// //       supplierName: 'شركة الأوراق المحدودة'
// //     },
// //     {
// //       id: '2',
// //       invoiceNumber: 'INV-2023-002',
// //       invoiceDate: '2023-11-20',
// //       totalAmount: 7500,
// //       remainingBalance: 7500,
// //       currencyCode: 'SAR',
// //       description: 'فاتورة خدمات تقنية',
// //       supplierName: 'شركة التقنية المتطورة'
// //     },
// //     {
// //       id: '3',
// //       invoiceNumber: 'INV-2023-003',
// //       invoiceDate: '2023-12-05',
// //       totalAmount: 12000,
// //       remainingBalance: 8000,
// //       currencyCode: 'SAR',
// //       description: 'فاتورة أثاث مكاتب',
// //       supplierName: 'مؤسسة الأثاث الحديث'
// //     },
// //     {
// //       id: '4',
// //       invoiceNumber: 'INV-2024-001',
// //       invoiceDate: '2024-01-10',
// //       totalAmount: 3000,
// //       remainingBalance: 1500,
// //       currencyCode: 'SAR',
// //       description: 'فاتورة صيانة دورية',
// //       supplierName: 'شركة الصيانة الشاملة'
// //     },
// //     {
// //       id: '5',
// //       invoiceNumber: 'INV-2024-002',
// //       invoiceDate: '2024-02-15',
// //       totalAmount: 6000,
// //       remainingBalance: 6000,
// //       currencyCode: 'SAR',
// //       description: 'فاتورة برامج وتطبيقات',
// //       supplierName: 'شركة الحلول البرمجية'
// //     }
// //   ];

// //   // استخدام البيانات الثابتة إذا لم يتم توفير بيانات من الـ props
// //   const invoices1 = outstandingInvoices || staticOutstandingInvoices;

// //   // حساب إجمالي مبلغ الفاتورة
// //   const totalInvoiceAmount =
// //     formik.values.apInvoiceLinesList?.reduce((sum: number, item: any) => sum + (Number(item.total) || 0), 0) || 0;

// //   // تهيئة appliedInvoices إذا لم تكن موجودة
// //   const [localAppliedInvoices, setLocalAppliedInvoices] = useState<AppliedInvoice[]>(
// //     formik.values.appliedInvoices || []
// //   );

// //   // تحديث Formik عندما تتغير localAppliedInvoices
// //   useEffect(() => {
// //     formik.setFieldValue('appliedInvoices', localAppliedInvoices);
// //   }, [localAppliedInvoices]);

// //   // حساب إجمالي المبلغ المطبق
// //   const totalAppliedAmount = localAppliedInvoices.reduce(
// //     (sum: number, item: AppliedInvoice) => sum + (item.appliedAmount || 0),
// //     0
// //   );

// //   // حساب المبلغ المتبقي للتطبيق
// //   const remainingAmount = totalInvoiceAmount - totalAppliedAmount;

// //   // تحديث المبلغ المطبق لفاتورة محددة
// //   const updateAppliedAmount = (invoiceId: string, amount: number) => {
// //     const invoice = invoices1.find(inv => inv.id === invoiceId);
// //     if (!invoice) return;

// //     // التحقق من أن المبلغ لا يتجاوز الرصيد المتبقي
// //     const maxAmount = Math.min(invoice.remainingBalance, remainingAmount + (getCurrentAppliedAmount(invoiceId) || 0));
// //     const finalAmount = Math.min(amount, maxAmount);

// //     const existingIndex = localAppliedInvoices.findIndex(item => item.invoiceId === invoiceId);

// //     if (finalAmount > 0) {
// //       if (existingIndex >= 0) {
// //         // تحديث الفاتورة الموجودة
// //         const updated = [...localAppliedInvoices];
// //         updated[existingIndex] = {
// //           ...updated[existingIndex],
// //           appliedAmount: finalAmount
// //         };
// //         setLocalAppliedInvoices(updated);
// //       } else {
// //         // إضافة فاتورة جديدة
// //         setLocalAppliedInvoices([
// //           ...localAppliedInvoices,
// //           {
// //             invoiceId,
// //             invoiceNumber: invoice.invoiceNumber,
// //             appliedAmount: finalAmount,
// //             remainingBalance: invoice.remainingBalance,
// //             currencyCode: invoice.currencyCode
// //           }
// //         ]);
// //       }
// //     } else {
// //       // إذا كان المبلغ صفراً أو أقل، إزالة الفاتورة من القائمة
// //       if (existingIndex >= 0) {
// //         const updated = localAppliedInvoices.filter(item => item.invoiceId !== invoiceId);
// //         setLocalAppliedInvoices(updated);
// //       }
// //     }
// //   };

// //   // الحصول على المبلغ المطبق الحالي لفاتورة محددة
// //   const getCurrentAppliedAmount = (invoiceId: string): number => {
// //     const applied = localAppliedInvoices.find(item => item.invoiceId === invoiceId);
// //     return applied?.appliedAmount || 0;
// //   };

// //   // التوزيع التلقائي للمبلغ المتبقي
// //   const autoDistribute = () => {
// //     if (remainingAmount <= 0) return;

// //     const eligibleInvoices = invoices1.filter(invoice => invoice.remainingBalance > 0);

// //     if (eligibleInvoices.length === 0) return;

// //     // توزيع المبلغ بنسبة الرصيد المتبقي لكل فاتورة
// //     const totalRemainingBalance = eligibleInvoices.reduce((sum, invoice) => sum + invoice.remainingBalance, 0);

// //     let distributedAmount = 0;
// //     const newAppliedInvoices = [...localAppliedInvoices];

// //     eligibleInvoices.forEach((invoice, index) => {
// //       if (distributedAmount >= remainingAmount) return;

// //       const proportion = invoice.remainingBalance / totalRemainingBalance;
// //       let amount =
// //         index === eligibleInvoices.length - 1
// //           ? remainingAmount - distributedAmount // المتبقي للفاتورة الأخيرة
// //           : Math.min(invoice.remainingBalance, remainingAmount * proportion);

// //       amount = Math.min(amount, remainingAmount - distributedAmount);

// //       if (amount > 0) {
// //         const existingIndex = newAppliedInvoices.findIndex(item => item.invoiceId === invoice.id);

// //         if (existingIndex >= 0) {
// //           // تحديث المبلغ المطبق الحالي
// //           newAppliedInvoices[existingIndex].appliedAmount += amount;
// //         } else {
// //           // إضافة فاتورة جديدة
// //           newAppliedInvoices.push({
// //             invoiceId: invoice.id,
// //             invoiceNumber: invoice.invoiceNumber,
// //             appliedAmount: amount,
// //             remainingBalance: invoice.remainingBalance,
// //             currencyCode: invoice.currencyCode
// //           });
// //         }
// //         distributedAmount += amount;
// //       }
// //     });

// //     setLocalAppliedInvoices(newAppliedInvoices);
// //   };

// //   // مسح كل التطبيقات
// //   const clearAllApplications = () => {
// //     setLocalAppliedInvoices([]);
// //   };

// //   // الحصول على الفواتير التي تم تطبيق مبلغ عليها
// //   const getAppliedInvoicesCount = (): number => {
// //     return localAppliedInvoices.filter(item => item.appliedAmount > 0).length;
// //   };

// //   return (
// //     <div className='row'>
// //       <div className='col-12'>
// //         <div className='alert alert-info'>
// //           <i className='fas fa-info-circle me-2'></i>
// //           {t('يمكنك تطبيق الإشعار الدائن على عدة فواتير للمورد عن طريق إدخال المبلغ في الحقل المقابل لكل فاتورة')}
// //         </div>
// //       </div>

// //       {/* ملخص المبالغ */}
// //       <div className='col-12 mb-4'>
// //         <div className='card border-primary'>
// //           <div className='card-body'>
// //             <div className='row text-center'>
// //               <div className='col-md-3'>
// //                 <h6 className='text-muted'>{t('مبلغ الإشعار الدائن')}</h6>
// //                 <h4 className='text-primary'>
// //                   {totalInvoiceAmount.toLocaleString()} {formik.values.currencyCode}
// //                 </h4>
// //               </div>
// //               <div className='col-md-3'>
// //                 <h6 className='text-muted'>{t('المبلغ المطبق')}</h6>
// //                 <h4 className='text-success'>
// //                   {totalAppliedAmount.toLocaleString()} {formik.values.currencyCode}
// //                 </h4>
// //               </div>
// //               <div className='col-md-3'>
// //                 <h6 className='text-muted'>{t('المبلغ المتبقي')}</h6>
// //                 <h4 className={remainingAmount > 0 ? 'text-warning' : 'text-success'}>
// //                   {remainingAmount.toLocaleString()} {formik.values.currencyCode}
// //                 </h4>
// //               </div>
// //               <div className='col-md-3'>
// //                 <h6 className='text-muted'>{t('الفواتير المحددة')}</h6>
// //                 <h4 className='text-info'>{getAppliedInvoicesCount()}</h4>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* أزرار التحكم */}
// //       <div className='col-12 mb-3'>
// //         <div className='d-flex justify-content-between align-items-center'>
// //           <div>
// //             <Button variant='outline-success' onClick={autoDistribute} disabled={remainingAmount <= 0} className='me-2'>
// //               <i className='fas fa-magic me-2'></i>
// //               {t('توزيع تلقائي للمبلغ المتبقي')}
// //             </Button>
// //             <div className='form-text d-inline-block'>{t('سيتم توزيع المبلغ المتبقي على جميع الفواتير المتاحة')}</div>
// //           </div>

// //           {localAppliedInvoices.length > 0 && (
// //             <Button variant='outline-danger' onClick={clearAllApplications}>
// //               <i className='fas fa-trash me-2'></i>
// //               {t('مسح كل المبالغ')}
// //             </Button>
// //           )}
// //         </div>
// //       </div>

// //       {/* جدول الفواتير */}
// //       <div className='col-12'>
// //         <div className='card'>
// //           <div className='card-header'>
// //             <h6 className='card-title mb-0'>
// //               <i className='fas fa-table me-2'></i>
// //               {t('الفواتير المتاحة للتطبيق')}
// //             </h6>
// //           </div>
// //           <div className='card-body p-0'>
// //             <Table responsive striped hover className='mb-0'>
// //               <thead className='bg-light'>
// //                 <tr>
// //                   <th>#</th>
// //                   <th>{t('رقم الفاتورة')}</th>
// //                   <th>{t('تاريخ الفاتورة')}</th>
// //                   <th>{t('الوصف')}</th>
// //                   <th>{t('المبلغ الأصلي')}</th>
// //                   <th>{t('الرصيد المتبقي')}</th>
// //                   <th>{t('المبلغ المطبق')}</th>
// //                 </tr>
// //               </thead>
// //               <tbody>
// //                 {invoices1.map((invoice, index) => {
// //                   const currentAppliedAmount = getCurrentAppliedAmount(invoice.id);
// //                   const maxAllowed = Math.min(invoice.remainingBalance, remainingAmount + currentAppliedAmount);

// //                   return (
// //                     <tr key={invoice.id} className={currentAppliedAmount > 0 ? 'table-success' : ''}>
// //                       <td>{index + 1}</td>
// //                       <td>
// //                         <strong>{invoice.invoiceNumber}</strong>
// //                       </td>
// //                       <td>{invoice.invoiceDate}</td>
// //                       <td>
// //                         <div className='text-muted small' title={invoice.description}>
// //                           {invoice.description && invoice.description.length > 50
// //                             ? `${invoice.description.substring(0, 50)}...`
// //                             : invoice.description}
// //                         </div>
// //                         {invoice.supplierName && <div className='text-muted small'>{invoice.supplierName}</div>}
// //                       </td>
// //                       <td>
// //                         {invoice.totalAmount.toLocaleString(undefined, {
// //                           minimumFractionDigits: 2,
// //                           maximumFractionDigits: 2
// //                         })}{' '}
// //                         {invoice.currencyCode}
// //                       </td>
// //                       <td>
// //                         <span className={invoice.remainingBalance > 0 ? 'fw-bold text-success' : 'text-muted'}>
// //                           {invoice.remainingBalance.toLocaleString(undefined, {
// //                             minimumFractionDigits: 2,
// //                             maximumFractionDigits: 2
// //                           })}{' '}
// //                           {invoice.currencyCode}
// //                         </span>
// //                       </td>
// //                       <td>
// //                         <div className='d-flex align-items-center'>
// //                           <Form.Control
// //                             type='number'
// //                             value={currentAppliedAmount || ''}
// //                             onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
// //                               const value = parseFloat(e.target.value) || 0;
// //                               updateAppliedAmount(invoice.id, value);
// //                             }}
// //                             onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
// //                               const value = parseFloat(e.target.value) || 0;
// //                               updateAppliedAmount(invoice.id, value);
// //                             }}
// //                             step='0.01'
// //                             min='0'
// //                             max={maxAllowed}
// //                             placeholder='0.00'
// //                             size='sm'
// //                             className='me-2'
// //                           />
// //                           <Badge
// //                             bg={currentAppliedAmount > 0 ? 'success' : 'secondary'}
// //                             className={currentAppliedAmount > 0 ? '' : 'opacity-50'}
// //                           >
// //                             {invoice.currencyCode}
// //                           </Badge>
// //                         </div>
// //                         <div className='form-text small text-center'>
// //                           {currentAppliedAmount > 0 && (
// //                             <span>{((currentAppliedAmount / totalInvoiceAmount) * 100).toFixed(1)}%</span>
// //                           )}
// //                         </div>
// //                       </td>
// //                     </tr>
// //                   );
// //                 })}
// //               </tbody>
// //               <tfoot className='bg-light'>
// //                 <tr>
// //                   <td colSpan={5} className='text-end fw-bold'>
// //                     {t('المجموع:')}
// //                   </td>
// //                   <td className='fw-bold'>
// //                     {invoices1
// //                       .reduce((sum, inv) => sum + inv.remainingBalance, 0)
// //                       .toLocaleString(undefined, {
// //                         minimumFractionDigits: 2,
// //                         maximumFractionDigits: 2
// //                       })}{' '}
// //                     {formik.values.currencyCode}
// //                   </td>
// //                   <td className='fw-bold text-success'>
// //                     {totalAppliedAmount.toLocaleString(undefined, {
// //                       minimumFractionDigits: 2,
// //                       maximumFractionDigits: 2
// //                     })}{' '}
// //                     {formik.values.currencyCode}
// //                   </td>
// //                 </tr>
// //               </tfoot>
// //             </Table>
// //           </div>
// //         </div>
// //       </div>

// //       {/* تحذيرات وإشعارات */}
// //       <div className='col-12 mt-3'>
// //         {remainingAmount > 0 && (
// //           <Alert variant='warning' className='d-flex align-items-center'>
// //             <i className='fas fa-exclamation-triangle me-2 fs-5'></i>
// //             <div>
// //               <strong>{t('ملاحظة:')}</strong> {t('لم يتم تطبيق المبلغ بالكامل. المبلغ المتبقي:')}{' '}
// //               <strong>
// //                 {remainingAmount.toLocaleString(undefined, {
// //                   minimumFractionDigits: 2,
// //                   maximumFractionDigits: 2
// //                 })}{' '}
// //                 {formik.values.currencyCode}
// //               </strong>
// //             </div>
// //           </Alert>
// //         )}

// //         {remainingAmount === 0 && totalAppliedAmount > 0 && (
// //           <Alert variant='success' className='d-flex align-items-center'>
// //             <i className='fas fa-check-circle me-2 fs-5'></i>
// //             <div>
// //               <strong>{t('ممتاز!')}</strong> {t('تم تطبيق المبلغ بالكامل على الفواتير المحددة.')}
// //             </div>
// //           </Alert>
// //         )}

// //         {remainingAmount < 0 && (
// //           <Alert variant='danger' className='d-flex align-items-center'>
// //             <i className='fas fa-exclamation-circle me-2 fs-5'></i>
// //             <div>
// //               <strong>{t('خطأ:')}</strong> {t('المبلغ المطبق يتجاوز مبلغ الإشعار الدائن. يرجى تعديل المبالغ.')}
// //             </div>
// //           </Alert>
// //         )}

// //         {getAppliedInvoicesCount() === 0 && (
// //           <Alert variant='info' className='d-flex align-items-center'>
// //             <i className='fas fa-info-circle me-2 fs-5'></i>
// //             <div>
// //               <strong>{t('تعليمات:')}</strong> {t('قم بإدخال المبالغ المراد تطبيقها في الحقول المقابلة لكل فاتورة.')}
// //             </div>
// //           </Alert>
// //         )}
// //       </div>

// //       {/* ملخص الفواتير المطبقة */}
// //       {getAppliedInvoicesCount() > 0 && (
// //         <div className='col-12 mt-3'>
// //           <div className='card border-success'>
// //             <div className='card-header bg-success text-white'>
// //               <h6 className='card-title mb-0'>
// //                 <i className='fas fa-list-check me-2'></i>
// //                 {t('ملخص التطبيق')} ({getAppliedInvoicesCount()} {t('فاتورة')})
// //               </h6>
// //             </div>
// //             <div className='card-body'>
// //               <div className='row'>
// //                 {localAppliedInvoices
// //                   .filter(item => item.appliedAmount > 0)
// //                   .map((applied, index) => {
// //                     const invoice = invoices1.find(inv => inv.id === applied.invoiceId);
// //                     const percentage = ((applied.appliedAmount / totalInvoiceAmount) * 100).toFixed(1);

// //                     return (
// //                       <div key={applied.invoiceId} className='col-md-6 col-lg-4 mb-2'>
// //                         <div className='border rounded p-2 bg-light'>
// //                           <div className='d-flex justify-content-between align-items-center'>
// //                             <strong className='text-primary'>{applied.invoiceNumber}</strong>
// //                             <Badge bg='success'>{percentage}%</Badge>
// //                           </div>
// //                           <div className='small text-muted'>{invoice?.description}</div>
// //                           <div className='d-flex justify-content-between mt-1'>
// //                             <span>{t('المبلغ:')}</span>
// //                             <strong>
// //                               {applied.appliedAmount.toLocaleString(undefined, {
// //                                 minimumFractionDigits: 2,
// //                                 maximumFractionDigits: 2
// //                               })}{' '}
// //                               {applied.currencyCode}
// //                             </strong>
// //                           </div>
// //                         </div>
// //                       </div>
// //                     );
// //                   })}
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       {/* تعليمات الاستخدام */}
// //       <div className='col-12 mt-3'>
// //         <div className='card border-info'>
// //           <div className='card-header bg-info text-white py-2'>
// //             <h6 className='card-title mb-0'>
// //               <i className='fas fa-info-circle me-2'></i>
// //               {t('تعليمات الاستخدام')}
// //             </h6>
// //           </div>
// //           <div className='card-body'>
// //             <ol className='mb-0'>
// //               <li>{t('قم بإدخال المبلغ المراد تطبيقه في الحقل المقابل لكل فاتورة')}</li>
// //               <li>{t('يمكنك استخدام زر "توزيع تلقائي" لتوزيع المبلغ المتبقي على جميع الفواتير')}</li>
// //               <li>{t('الصفوف التي تحتوي على مبلغ مطبق ستظهر بلون أخضر')}</li>
// //               <li>{t('المبلغ المدخل لا يمكن أن يتجاوز الرصيد المتبقي للفاتورة')}</li>
// //               <li>{t('المبلغ الإجمالي المطبق لا يمكن أن يتجاوز مبلغ الإشعار الدائن')}</li>
// //             </ol>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default ApDebitMemoApplication;

// // ApDebitMemoApplication.tsx
// import React, { useState, useEffect } from 'react';
// import { useTranslation } from 'react-i18next';
// import { Form, Table, Button, Badge, Alert } from 'react-bootstrap';
// import type { FormikProps } from 'formik';
// import Loading from '@components/Shared/Loader/Loading';
// import { type UnPaymentSchedulesModels } from '@store/Finance/AP/ApInvoices/ApInvoicesModels';
// import { fetchUnpaidInvoices } from '@store/Finance/AP/ApInvoices/UnpaidInvoicesSlice';
// import { useAppDispatch } from '@store/hooks';
// import { Card } from '@components/card/card';

// // أنواع البيانات
// interface OutstandingInvoice {
//   id: string;
//   invoiceNumber: string;
//   invoiceDate: string;
//   totalAmount: number;
//   remainingBalance: number;
//   currencyCode: string;
//   description?: string;
//   supplierName?: string;
// }

// interface AppliedInvoice {
//   invoiceId: string;
//   invoiceNumber: string;
//   appliedAmount: number;
//   remainingBalance: number;
//   currencyCode: string;
// }

// interface FormValues {
//   invoiceNum: string;
//   peopleId: string;
//   invoiceType: string;
//   referenceType: string;
//   referenceId: string;
//   invoiceDate: string;
//   organizationId: string;
//   paymentTermsId: string;
//   paymentMethodId: string;
//   currencyCode: string;
//   currencyConversionRate: number;
//   includeVatFlag: boolean;
//   apInvoiceLinesList: any[];
//   apPaymentSchedulesList: any[];
//   appliedToInvoiceId: string;
//   appliedAmount: number;
//   appliedInvoices?: AppliedInvoice[];
// }

// interface ApDebitMemoApplicationProps {
//   formik: FormikProps<FormValues>;
//   outstandingInvoices?: OutstandingInvoice[];
//   loading?: boolean;
//   error?: string | null;
// }

// const ApDebitMemoApplication: React.FC<ApDebitMemoApplicationProps> = ({
//   formik,
//   outstandingInvoices,
//   loading = false,
//   error = null
// }) => {
//   const { values } = formik;
//   const dispatch = useAppDispatch();

//   const [invoices, setInvoices] = useState<UnPaymentSchedulesModels[]>([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [fetchError, setFetchError] = useState<string | null>(null);

//   const { t } = useTranslation();

//   // تحويل البيانات من السيرفر إلى الشكل المطلوب
//   const convertServerDataToOutstandingInvoices = (serverData: UnPaymentSchedulesModels[]): OutstandingInvoice[] => {
//     return serverData.map(invoice => ({
//       id: invoice.invoiceId,
//       invoiceNumber: invoice.invoiceNum,
//       invoiceDate: invoice.invoiceDate,
//       totalAmount: invoice.invoiceAmount,
//       remainingBalance: invoice.remainingAmount,
//       currencyCode: invoice.currencyCode,
//       description: `فاتورة ${invoice.invoiceNum} - ${invoice.peopleName}`,
//       supplierName: invoice.peopleName
//     }));
//   };

//   const handleGetUnpaidInvoices = async () => {
//     if (!values.organizationId || !values.peopleId) return;

//     setIsLoading(true);
//     setFetchError(null);

//     try {
//       const data = await dispatch(
//         fetchUnpaidInvoices({
//           peopleId: values.peopleId,
//           organizationId: values.organizationId,
//           invoiceType: 'Standard'
//         })
//       ).unwrap();

//       if (data.succeeded) {
//         setInvoices(data.data || []);
//         if (!data.data || data.data.length === 0) {
//           setFetchError(t('لم يتم العثور على فواتير'));
//         }
//       } else {
//         setFetchError(t('فشل في جلب الفواتير'));
//       }
//     } catch (error) {
//       console.error('Error fetching unpaid invoices:', error);
//       setFetchError(t('فشل في جلب الفواتير'));
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (values.peopleId && values.organizationId) {
//       handleGetUnpaidInvoices();
//     }
//   }, [values.peopleId, values.organizationId]);

//   // استخدام البيانات من السيرفر بعد تحويلها
//   const serverInvoices = convertServerDataToOutstandingInvoices(invoices);

//   // بيانات ثابتة للفواتير المعلقة (كاحتياطي)
//   const staticOutstandingInvoices: OutstandingInvoice[] = [
//     {
//       id: '1',
//       invoiceNumber: 'INV-2023-001',
//       invoiceDate: '2023-10-15',
//       totalAmount: 5000,
//       remainingBalance: 3000,
//       currencyCode: 'SAR',
//       description: 'فاتورة مواد مكتبية - أكتوبر 2023',
//       supplierName: 'شركة الأوراق المحدودة'
//     }
//   ];

//   // استخدام البيانات من السيرفر أولاً، ثم البيانات الثابتة إذا لم تكن هناك بيانات
//   const displayInvoices = serverInvoices.length > 0 ? serverInvoices : outstandingInvoices || staticOutstandingInvoices;

//   // حساب إجمالي مبلغ الفاتورة
//   const totalInvoiceAmount =
//     formik.values.apInvoiceLinesList?.reduce((sum: number, item: any) => sum + (Number(item.total) || 0), 0) || 0;

//   // تهيئة appliedInvoices إذا لم تكن موجودة
//   const [localAppliedInvoices, setLocalAppliedInvoices] = useState<AppliedInvoice[]>(
//     formik.values.appliedInvoices || []
//   );

//   // تحديث Formik عندما تتغير localAppliedInvoices
//   useEffect(() => {
//     formik.setFieldValue('appliedInvoices', localAppliedInvoices);
//   }, [localAppliedInvoices]);

//   // حساب إجمالي المبلغ المطبق
//   const totalAppliedAmount = localAppliedInvoices.reduce(
//     (sum: number, item: AppliedInvoice) => sum + (item.appliedAmount || 0),
//     0
//   );

//   // حساب المبلغ المتبقي للتطبيق
//   const remainingAmount = totalInvoiceAmount - totalAppliedAmount;

//   // تحديث المبلغ المطبق لفاتورة محددة
//   const updateAppliedAmount = (invoiceId: string, amount: number) => {
//     const invoice = displayInvoices.find(inv => inv.id === invoiceId);
//     if (!invoice) return;

//     // التحقق من أن المبلغ لا يتجاوز الرصيد المتبقي
//     const currentApplied = getCurrentAppliedAmount(invoiceId);
//     const maxAmount = Math.min(invoice.remainingBalance, remainingAmount + currentApplied);
//     const finalAmount = Math.max(0, Math.min(amount, maxAmount));

//     const existingIndex = localAppliedInvoices.findIndex(item => item.invoiceId === invoiceId);

//     if (finalAmount > 0) {
//       if (existingIndex >= 0) {
//         // تحديث الفاتورة الموجودة
//         const updated = [...localAppliedInvoices];
//         updated[existingIndex] = {
//           ...updated[existingIndex],
//           appliedAmount: finalAmount
//         };
//         setLocalAppliedInvoices(updated);
//       } else {
//         // إضافة فاتورة جديدة
//         setLocalAppliedInvoices([
//           ...localAppliedInvoices,
//           {
//             invoiceId,
//             invoiceNumber: invoice.invoiceNumber,
//             appliedAmount: finalAmount,
//             remainingBalance: invoice.remainingBalance,
//             currencyCode: invoice.currencyCode
//           }
//         ]);
//       }
//     } else {
//       // إذا كان المبلغ صفراً أو أقل، إزالة الفاتورة من القائمة
//       if (existingIndex >= 0) {
//         const updated = localAppliedInvoices.filter(item => item.invoiceId !== invoiceId);
//         setLocalAppliedInvoices(updated);
//       }
//     }
//   };

//   // الحصول على المبلغ المطبق الحالي لفاتورة محددة
//   const getCurrentAppliedAmount = (invoiceId: string): number => {
//     const applied = localAppliedInvoices.find(item => item.invoiceId === invoiceId);
//     return applied?.appliedAmount || 0;
//   };

//   // التوزيع التلقائي للمبلغ المتبقي
//   const autoDistribute = () => {
//     if (remainingAmount <= 0) return;

//     const eligibleInvoices = displayInvoices.filter(
//       invoice => invoice.remainingBalance > 0 && getCurrentAppliedAmount(invoice.id) < invoice.remainingBalance
//     );

//     if (eligibleInvoices.length === 0) return;

//     // توزيع المبلغ بنسبة الرصيد المتبقي لكل فاتورة
//     const totalRemainingBalance = eligibleInvoices.reduce(
//       (sum, invoice) => sum + (invoice.remainingBalance - getCurrentAppliedAmount(invoice.id)),
//       0
//     );

//     let distributedAmount = 0;
//     const newAppliedInvoices = [...localAppliedInvoices];

//     eligibleInvoices.forEach((invoice, index) => {
//       if (distributedAmount >= remainingAmount) return;

//       const availableBalance = invoice.remainingBalance - getCurrentAppliedAmount(invoice.id);
//       const proportion = availableBalance / totalRemainingBalance;

//       let amount =
//         index === eligibleInvoices.length - 1
//           ? remainingAmount - distributedAmount
//           : Math.min(availableBalance, remainingAmount * proportion);

//       amount = Math.min(amount, remainingAmount - distributedAmount);

//       if (amount > 0) {
//         const existingIndex = newAppliedInvoices.findIndex(item => item.invoiceId === invoice.id);

//         if (existingIndex >= 0) {
//           // تحديث المبلغ المطبق الحالي
//           newAppliedInvoices[existingIndex].appliedAmount += amount;
//         } else {
//           // إضافة فاتورة جديدة
//           newAppliedInvoices.push({
//             invoiceId: invoice.id,
//             invoiceNumber: invoice.invoiceNumber,
//             appliedAmount: amount,
//             remainingBalance: invoice.remainingBalance,
//             currencyCode: invoice.currencyCode
//           });
//         }
//         distributedAmount += amount;
//       }
//     });

//     setLocalAppliedInvoices(newAppliedInvoices);
//   };

//   // مسح كل التطبيقات
//   const clearAllApplications = () => {
//     setLocalAppliedInvoices([]);
//   };

//   // الحصول على الفواتير التي تم تطبيق مبلغ عليها
//   const getAppliedInvoicesCount = (): number => {
//     return localAppliedInvoices.filter(item => item.appliedAmount > 0).length;
//   };

//   // إعادة تحميل البيانات
//   const handleReload = () => {
//     handleGetUnpaidInvoices();
//   };

//   return (
//     <div className='row px-2'>
//       {/* أزرار التحكم */}
//       {/* <div className='col-12 mb-3'>
//         <div className='d-flex justify-content-between align-items-center'>
//           <div>
//             <Button variant='outline-primary' onClick={handleReload} disabled={isLoading} className='me-2'>
//               <i className={`fas fa-sync ${isLoading ? 'fa-spin' : ''} me-2`}></i>
//               {t('تحديث البيانات')}
//             </Button>
//             <Button
//               variant='outline-success'
//               onClick={autoDistribute}
//               disabled={remainingAmount <= 0 || isLoading}
//               className='me-2'
//             >
//               <i className='fas fa-magic me-2'></i>
//               {t('توزيع تلقائي للمبلغ المتبقي')}
//             </Button>
//             <div className='form-text d-inline-block'>{t('سيتم توزيع المبلغ المتبقي على جميع الفواتير المتاحة')}</div>
//           </div>

//           {localAppliedInvoices.length > 0 && (
//             <Button variant='outline-danger' onClick={clearAllApplications}>
//               <i className='fas fa-trash me-2'></i>
//               {t('مسح كل المبالغ')}
//             </Button>
//           )}
//         </div>
//       </div> */}

//       {/* حالة التحميل والخطأ */}
//       <Loading loading={isLoading || loading} error={fetchError || error} Type='Dots'>
//         {/* ملخص المبالغ */}

//         <div className='col-12 mb-2'>
//           <div className='row'>
//             {/* كارت مبلغ الإشعار الدائن */}
//             <div className='col-xl-3 col-md-6 mb-3'>
//               <Card className='card border-primary h-100'>
//                 <div className='card-body'>
//                   <div className='d-flex align-items-center'>
//                     <div className='flex-shrink-0'>
//                       <div className='bg-primary bg-opacity-10 rounded-3 p-3'>
//                         <i className='fas fa-file-invoice-dollar fs-2 text-primary'></i>
//                       </div>
//                     </div>
//                     <div className='flex-grow-1 ms-3'>
//                       <h6 className='card-title text-muted mb-1'>{t('مبلغ الإشعار الدائن')}</h6>
//                       <h4 className='text-primary mb-0'>
//                         {totalInvoiceAmount.toLocaleString(undefined, {
//                           minimumFractionDigits: 2,
//                           maximumFractionDigits: 2
//                         })}
//                       </h4>
//                       <small className='text-muted'>{formik.values.currencyCode}</small>
//                     </div>
//                   </div>
//                 </div>
//               </Card>
//             </div>

//             {/* كارت المبلغ المطبق */}
//             <div className='col-xl-3 col-md-6 mb-3'>
//               <Card className=' h-100'>
//                 <div className='card-body'>
//                   <div className='d-flex align-items-center'>
//                     <div className='flex-shrink-0'>
//                       <div className='bg-success bg-opacity-10 rounded-3 p-3'>
//                         <i className='fas fa-check-circle fs-2 text-success'></i>
//                       </div>
//                     </div>
//                     <div className='flex-grow-1 ms-3'>
//                       <h6 className='card-title text-muted mb-1'>{t('المبلغ المطبق')}</h6>
//                       <h4 className='text-success mb-0'>
//                         {totalAppliedAmount.toLocaleString(undefined, {
//                           minimumFractionDigits: 2,
//                           maximumFractionDigits: 2
//                         })}
//                       </h4>
//                       <small className='text-muted'>{formik.values.currencyCode}</small>
//                     </div>
//                   </div>
//                 </div>
//               </Card>
//             </div>

//             {/* كارت المبلغ المتبقي */}
//             <div className='col-xl-3 col-md-6 mb-3'>
//               <Card className=' h-100'>
//                 <div className={`card h-100 ${remainingAmount > 0 ? 'border-warning' : 'border-success'}`}>
//                   <div className='card-body'>
//                     <div className='d-flex align-items-center'>
//                       <div className='flex-shrink-0'>
//                         <div
//                           className={`rounded-3 p-3 ${
//                             remainingAmount > 0 ? 'bg-warning bg-opacity-10' : 'bg-success bg-opacity-10'
//                           }`}
//                         >
//                           <i
//                             className={`fas ${
//                               remainingAmount > 0 ? 'fa-clock text-warning' : 'fa-check-double text-success'
//                             } fs-2`}
//                           ></i>
//                         </div>
//                       </div>
//                       <div className='flex-grow-1 ms-3'>
//                         <h6 className='card-title text-muted mb-1'>{t('المبلغ المتبقي')}</h6>
//                         <h4 className={remainingAmount > 0 ? 'text-warning' : 'text-success'}>
//                           {remainingAmount.toLocaleString(undefined, {
//                             minimumFractionDigits: 2,
//                             maximumFractionDigits: 2
//                           })}
//                         </h4>
//                         <small className='text-muted'>{formik.values.currencyCode}</small>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </Card>
//             </div>

//             {/* كارت الفواتير المحددة */}
//             <div className='col-xl-3 col-md-6 mb-3'>
//               <Card className=' h-100'>
//                 <div className='card-body'>
//                   <div className='d-flex align-items-center'>
//                     <div className='flex-shrink-0'>
//                       <div className='bg-info bg-opacity-10 rounded-3 p-3'>
//                         <i className='fas fa-list-check fs-2 text-info'></i>
//                       </div>
//                     </div>
//                     <div className='flex-grow-1 ms-3'>
//                       <h6 className='card-title text-muted mb-1'>{t('الفواتير المحددة')}</h6>
//                       <h4 className='text-info mb-0'>{getAppliedInvoicesCount()}</h4>
//                       {/* <small className='text-muted'>{t('فاتورة')}</small> */}
//                     </div>
//                   </div>
//                 </div>
//               </Card>
//             </div>
//           </div>
//         </div>

//         {/* جدول الفواتير */}
//         <div className='col-12 m-0'>
//           <Card>
//             <div className='card'>
//               <div className='card-header d-flex justify-content-between align-items-center'>
//                 <h6 className='mb-0'>
//                   <i className='fas fa-file-invoice me-2'></i>
//                   {t('الفواتير المتاحة للتطبيق')}
//                 </h6>
//                 <span className='badge bg-theme'>
//                   {t('الفواتير المحددة')}: {getAppliedInvoicesCount()}
//                 </span>
//               </div>

//               <div className='card-body p-0'>
//                 <div className='table-responsive'>
//                   <table className='table table-hover mb-0'>
//                     <thead className='table-active fw-bold fs-5'>
//                       <tr>
//                         <th className='text-center small'>#</th>
//                         <th className='text-center small'>{t('رقم الفاتورة')}</th>
//                         <th className='text-center small'>{t('تاريخ الفاتورة')}</th>
//                         <th className='text-center small'>{t('الوصف')}</th>
//                         <th className='text-center small'>{t('المبلغ الأصلي')}</th>
//                         <th className='text-center small'>{t('الرصيد المتبقي')}</th>
//                         <th className='text-center small'>{t('المبلغ المطبق')}</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {displayInvoices.length > 0 ? (
//                         displayInvoices.map((invoice, index) => {
//                           const currentAppliedAmount = getCurrentAppliedAmount(invoice.id);
//                           const maxAllowed = Math.min(invoice.remainingBalance, remainingAmount + currentAppliedAmount);

//                           return (
//                             <tr key={invoice.id} className={currentAppliedAmount > 0 ? 'table-active' : ''}>
//                               <td className='text-center align-middle'>{index + 1}</td>
//                               <td className='text-center align-middle'>
//                                 <strong>{invoice.invoiceNumber}</strong>
//                               </td>
//                               <td className='text-center align-middle'>{invoice.invoiceDate}</td>
//                               <td className='text-center align-middle'>
//                                 <div className='text-muted small' title={invoice.description}>
//                                   {invoice.description && invoice.description.length > 50
//                                     ? `${invoice.description.substring(0, 50)}...`
//                                     : invoice.description}
//                                 </div>
//                                 {invoice.supplierName && <div className='text-muted small'>{invoice.supplierName}</div>}
//                               </td>
//                               <td className='text-center align-middle'>
//                                 {invoice.totalAmount.toLocaleString(undefined, {
//                                   minimumFractionDigits: 2,
//                                   maximumFractionDigits: 2
//                                 })}{' '}
//                               </td>
//                               <td className='text-center align-middle'>
//                                 <span className={invoice.remainingBalance > 0 ? 'fw-bold text-success' : 'text-muted'}>
//                                   {invoice.remainingBalance.toLocaleString(undefined, {
//                                     minimumFractionDigits: 2,
//                                     maximumFractionDigits: 2
//                                   })}
//                                 </span>
//                               </td>
//                               <td className='text-center align-middle'>
//                                 <div className='d-flex align-items-center justify-content-center'>
//                                   <Form.Control
//                                     type='number'
//                                     value={currentAppliedAmount || ''}
//                                     onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
//                                       const value = parseFloat(e.target.value) || 0;
//                                       updateAppliedAmount(invoice.id, value);
//                                     }}
//                                     onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
//                                       const value = parseFloat(e.target.value) || 0;
//                                       updateAppliedAmount(invoice.id, value);
//                                     }}
//                                     step='0.01'
//                                     min='0'
//                                     max={maxAllowed}
//                                     // placeholder='0.00'
//                                     // size='sm'
//                                     className='me-2 text-center fw-bold'
//                                     style={{ width: '120px' }}
//                                     disabled={invoice.remainingBalance <= 0}
//                                   />
//                                 </div>
//                               </td>
//                             </tr>
//                           );
//                         })
//                       ) : (
//                         <tr>
//                           <td colSpan={7} className='text-center py-4'>
//                             <i className='fas fa-receipt fa-2x text-muted mb-2'></i>
//                             <p className='text-muted'>{t('لا توجد فواتير لعرضها')}</p>
//                           </td>
//                         </tr>
//                       )}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>

//               <div className='card-footer d-flex justify-content-between align-items-center'>
//                 <div className='text-muted small'>
//                   {t('عرض')} {displayInvoices.length} {t('من')} {displayInvoices.length} {t('فاتورة')}
//                 </div>
//                 <div className='text-theme fw-bold'>
//                   {t('المبلغ الإجمالي المطبق')}:{' '}
//                   {totalAppliedAmount.toLocaleString(undefined, {
//                     minimumFractionDigits: 2,
//                     maximumFractionDigits: 2
//                   })}{' '}
//                   {formik.values.currencyCode}
//                 </div>
//               </div>
//             </div>
//           </Card>
//         </div>

//         {/* تحذيرات وإشعارات */}
//         <div className='col-12 mt-3'>
//           {remainingAmount > 0 && totalInvoiceAmount > 0 && (
//             <Alert variant='warning' className='d-flex align-items-center'>
//               <i className='fas fa-exclamation-triangle me-2 fs-5'></i>
//               <div>
//                 <strong>{t('ملاحظة:')}</strong> {t('لم يتم تطبيق المبلغ بالكامل. المبلغ المتبقي:')}{' '}
//                 <strong>
//                   {remainingAmount.toLocaleString(undefined, {
//                     minimumFractionDigits: 2,
//                     maximumFractionDigits: 2
//                   })}{' '}
//                   {formik.values.currencyCode}
//                 </strong>
//               </div>
//             </Alert>
//           )}

//           {remainingAmount === 0 && totalAppliedAmount > 0 && (
//             <Alert variant='success' className='d-flex align-items-center'>
//               <i className='fas fa-check-circle me-2 fs-5'></i>
//               <div>
//                 <strong>{t('ممتاز!')}</strong> {t('تم تطبيق المبلغ بالكامل على الفواتير المحددة.')}
//               </div>
//             </Alert>
//           )}

//           {remainingAmount < 0 && (
//             <Alert variant='danger' className='d-flex align-items-center'>
//               <i className='fas fa-exclamation-circle me-2 fs-5'></i>
//               <div>
//                 <strong>{t('خطأ:')}</strong> {t('المبلغ المطبق يتجاوز مبلغ الإشعار الدائن. يرجى تعديل المبالغ.')}
//               </div>
//             </Alert>
//           )}

//           {getAppliedInvoicesCount() === 0 && displayInvoices.length > 0 && (
//             <Alert variant='info' className='d-flex align-items-center'>
//               <i className='fas fa-info-circle me-2 fs-5'></i>
//               <div>
//                 <strong>{t('تعليمات:')}</strong> {t('قم بإدخال المبالغ المراد تطبيقها في الحقول المقابلة لكل فاتورة.')}
//               </div>
//             </Alert>
//           )}
//         </div>
//       </Loading>
//     </div>
//   );
// };

// export default ApDebitMemoApplication;

// ApDebitMemoApplication.tsx
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Button, Badge, Alert } from 'react-bootstrap';
import type { FormikProps } from 'formik';
import Loading from '@components/Shared/Loader/Loading';
import { type UnPaymentSchedulesModels } from '@store/Finance/AP/ApInvoices/ApInvoicesModels';
import { fetchUnpaidInvoices } from '@store/Finance/AP/ApInvoices/UnpaidInvoicesSlice';
import { useAppDispatch } from '@store/hooks';
import { Card } from '@components/card/card';

// أنواع البيانات
interface AppliedInvoice {
  invoiceId: string;
  invoiceNumber: string;
  appliedAmount: number;
  remainingBalance: number;
  currencyCode: string;
}

interface FormValues {
  invoiceNum: string;
  peopleId: string;
  invoiceType: string;
  referenceType: string;
  referenceId: string;
  invoiceDate: string;
  organizationId: string;
  paymentTermsId: string;
  paymentMethodId: string;
  currencyCode: string;
  currencyConversionRate: number;
  includeVatFlag: boolean;
  apInvoiceLinesList: any[];
  apPaymentSchedulesList: any[];
  appliedToInvoiceId: string;
  appliedAmount: number;
  appliedInvoices?: AppliedInvoice[];
}

interface ApDebitMemoApplicationProps {
  formik: FormikProps<FormValues>;
  loading?: boolean;
  error?: string | null;
}

const ApDebitMemoApplication: React.FC<ApDebitMemoApplicationProps> = ({ formik, loading = false, error = null }) => {
  const { values } = formik;
  const dispatch = useAppDispatch();

  const [invoices, setInvoices] = useState<UnPaymentSchedulesModels[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [fetchError, setFetchError] = useState<string | null>(null);

  const { t } = useTranslation();

  const handleGetUnpaidInvoices = async () => {
    if (!values.organizationId || !values.peopleId) return;

    setIsLoading(true);
    setFetchError(null);

    try {
      const data = await dispatch(
        fetchUnpaidInvoices({
          peopleId: values.peopleId,
          organizationId: values.organizationId,
          invoiceType: 'Standard'
        })
      ).unwrap();

      if (data.succeeded) {
        setInvoices(data.data || []);
        if (!data.data || data.data.length === 0) {
          setFetchError(t('لم يتم العثور على فواتير'));
        }
      } else {
        setFetchError(t('فشل في جلب الفواتير'));
      }
    } catch (error) {
      console.error('Error fetching unpaid invoices:', error);
      setFetchError(t('فشل في جلب الفواتير'));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (values.peopleId && values.organizationId) {
      handleGetUnpaidInvoices();
    }
  }, [values.peopleId, values.organizationId]);

  // استخدام البيانات مباشرة من السيرفر
  const displayInvoices = invoices;

  // حساب إجمالي مبلغ الفاتورة
  const totalInvoiceAmount =
    formik.values.apInvoiceLinesList?.reduce((sum: number, item: any) => sum + (Number(item.total) || 0), 0) || 0;

  // تهيئة appliedInvoices إذا لم تكن موجودة
  const [localAppliedInvoices, setLocalAppliedInvoices] = useState<AppliedInvoice[]>(
    formik.values.appliedInvoices || []
  );

  // تحديث Formik عندما تتغير localAppliedInvoices
  useEffect(() => {
    formik.setFieldValue('appliedInvoices', localAppliedInvoices);
  }, [localAppliedInvoices]);

  // حساب إجمالي المبلغ المطبق
  const totalAppliedAmount = localAppliedInvoices.reduce(
    (sum: number, item: AppliedInvoice) => sum + (item.appliedAmount || 0),
    0
  );

  // حساب المبلغ المتبقي للتطبيق
  const remainingAmount = totalInvoiceAmount - totalAppliedAmount;

  // تحديث المبلغ المطبق لفاتورة محددة
  const updateAppliedAmount = (invoiceId: string, amount: number) => {
    const invoice = displayInvoices.find(inv => inv.invoiceId === invoiceId);
    if (!invoice) return;

    // التحقق من أن المبلغ لا يتجاوز الرصيد المتبقي
    const currentApplied = getCurrentAppliedAmount(invoiceId);
    const maxAmount = Math.min(invoice.remainingAmount, remainingAmount + currentApplied);
    const finalAmount = Math.max(0, Math.min(amount, maxAmount));

    const existingIndex = localAppliedInvoices.findIndex(item => item.invoiceId === invoiceId);

    if (finalAmount > 0) {
      if (existingIndex >= 0) {
        // تحديث الفاتورة الموجودة
        const updated = [...localAppliedInvoices];
        updated[existingIndex] = {
          ...updated[existingIndex],
          appliedAmount: finalAmount
        };
        setLocalAppliedInvoices(updated);
      } else {
        // إضافة فاتورة جديدة
        setLocalAppliedInvoices([
          ...localAppliedInvoices,
          {
            invoiceId,
            invoiceNumber: invoice.invoiceNum,
            appliedAmount: finalAmount,
            remainingBalance: invoice.remainingAmount,
            currencyCode: invoice.currencyCode
          }
        ]);
      }
    } else {
      // إذا كان المبلغ صفراً أو أقل، إزالة الفاتورة من القائمة
      if (existingIndex >= 0) {
        const updated = localAppliedInvoices.filter(item => item.invoiceId !== invoiceId);
        setLocalAppliedInvoices(updated);
      }
    }
  };

  // الحصول على المبلغ المطبق الحالي لفاتورة محددة
  const getCurrentAppliedAmount = (invoiceId: string): number => {
    const applied = localAppliedInvoices.find(item => item.invoiceId === invoiceId);
    return applied?.appliedAmount || 0;
  };

  // الحصول على الفواتير التي تم تطبيق مبلغ عليها
  const getAppliedInvoicesCount = (): number => {
    return localAppliedInvoices.filter(item => item.appliedAmount > 0).length;
  };

  console.log(values.appliedInvoices);
  

  return (
    <div className='row px-2'>
      {/* حالة التحميل والخطأ */}
      <Loading loading={isLoading || loading} error={fetchError || error} Type='Dots'>
        {/* ملخص المبالغ */}
        <div className='col-12 mb-2'>
          <div className='row'>
            {/* كارت مبلغ الإشعار الدائن */}
            <div className='col-xl-3 col-md-6 mb-3'>
              <Card className='  h-100 shadow-sm'>
                <div className='card-body'>
                  <div className='d-flex align-items-center'>
                    <div className='flex-shrink-0'>
                      <div className='bg-primary bg-opacity-10 rounded-3 p-3'>
                        <i className='fas fa-file-invoice-dollar fs-2 text-primary'></i>
                      </div>
                    </div>
                    <div className='flex-grow-1 ms-3'>
                      <h6 className='card-title text-muted mb-1'>{t('مبلغ الإشعار الدائن')}</h6>
                      <h4 className='text-primary mb-0'>
                        {totalInvoiceAmount.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}
                      </h4>
                      <small className='text-muted'>{formik.values.currencyCode}</small>
                    </div>
                  </div>
                </div>
              </Card>
            </div>

            {/* كارت المبلغ المطبق */}
            <div className='col-xl-3 col-md-6 mb-3'>
              <Card className='h-100 shadow-sm'>
                <div className='card-body'>
                  <div className='d-flex align-items-center'>
                    <div className='flex-shrink-0'>
                      <div className='bg-success bg-opacity-10 rounded-3 p-3'>
                        <i className='fas fa-check-circle fs-2 text-success'></i>
                      </div>
                    </div>
                    <div className='flex-grow-1 ms-3'>
                      <h6 className='card-title text-muted mb-1'>{t('المبلغ المطبق')}</h6>
                      <h4 className='text-success mb-0'>
                        {totalAppliedAmount.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}
                      </h4>
                      <small className='text-muted'>{formik.values.currencyCode}</small>
                    </div>
                  </div>
                </div>
              </Card>
            </div>

            {/* كارت المبلغ المتبقي */}
            <div className='col-xl-3 col-md-6 mb-3'>
              <Card className='h-100 shadow-sm'>
                <div className={`card h-100 ${remainingAmount > 0 ? 'border-warning' : 'border-success'}`}>
                  <div className='card-body'>
                    <div className='d-flex align-items-center'>
                      <div className='flex-shrink-0'>
                        <div
                          className={`rounded-3 p-3 ${
                            remainingAmount > 0 ? 'bg-warning bg-opacity-10' : 'bg-success bg-opacity-10'
                          }`}
                        >
                          <i
                            className={`fas ${
                              remainingAmount > 0 ? 'fa-clock text-warning' : 'fa-check-double text-success'
                            } fs-2`}
                          ></i>
                        </div>
                      </div>
                      <div className='flex-grow-1 ms-3'>
                        <h6 className='card-title text-muted mb-1'>{t('المبلغ المتبقي')}</h6>
                        <h4 className={remainingAmount > 0 ? 'text-warning' : 'text-success'}>
                          {remainingAmount.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })}
                        </h4>
                        <small className='text-muted'>{formik.values.currencyCode}</small>
                      </div>
                    </div>
                  </div>
                </div>
              </Card>
            </div>

            {/* كارت الفواتير المحددة */}
            <div className='col-xl-3 col-md-6 mb-3'>
              <Card className='h-100 shadow-sm'>
                <div className='card-body'>
                  <div className='d-flex align-items-center'>
                    <div className='flex-shrink-0'>
                      <div className='bg-info bg-opacity-10 rounded-3 p-3'>
                        <i className='fas fa-list-check fs-2 text-info'></i>
                      </div>
                    </div>
                    <div className='flex-grow-1 ms-3'>
                      <h6 className='card-title text-muted mb-1'>{t('الفواتير المحددة')}</h6>
                      <h4 className='text-info mb-0'>{getAppliedInvoicesCount()}</h4>
                    </div>
                  </div>
                </div>
              </Card>
            </div>
          </div>
        </div>

        {/* جدول الفواتير */}
        <div className='col-12 m-0'>
          <Card>
            <div className='card'>
              <div className='card-header d-flex justify-content-between align-items-center'>
                <h6 className='mb-0'>
                  <i className='fas fa-file-invoice me-2'></i>
                  {t('الفواتير المتاحة للتطبيق')}
                </h6>
                <span className='badge bg-theme'>
                  {t('الفواتير المحددة')}: {getAppliedInvoicesCount()}
                </span>
              </div>

              <div className='card-body p-0'>
                <div className='table-responsive'>
                  <table className='table table-hover mb-0'>
                    <thead className='table-active fw-bold'>
                      <tr>
                        <th className='text-center small'>#</th>
                        <th className='text-center small'>{t('رقم الفاتورة')}</th>
                        <th className='text-center small'>{t('تاريخ الفاتورة')}</th>
                        <th className='text-center small'>{t('المورد')}</th>
                        <th className='text-center small'>{t('الوصف')}</th>
                        <th className='text-center small'>{t('المبلغ الأصلي')}</th>
                        <th className='text-center small'>{t('الرصيد المتبقي')}</th>
                        <th className='text-center small'>{t('المبلغ المطبق')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {displayInvoices.length > 0 ? (
                        displayInvoices.map((invoice, index) => {
                          const currentAppliedAmount = getCurrentAppliedAmount(invoice.invoiceId);
                          const maxAllowed = Math.min(invoice.remainingAmount, remainingAmount + currentAppliedAmount);

                          return (
                            <tr key={invoice.invoiceId} className={currentAppliedAmount > 0 ? 'table-active' : ''}>
                              <td className='text-center align-middle'>{index + 1}</td>
                              <td className='text-center align-middle'>
                                <strong>{invoice.invoiceNum}</strong>
                              </td>
                              <td className='text-center align-middle'>{invoice.invoiceDate}</td>
                              <td className='text-center align-middle'>
                                <div className='text-muted small'>{invoice.peopleName2}</div>
                              </td>
                              <td className='text-center align-middle'>
                                <div className='text-muted small'>وصف الفاتورة هنا</div>
                              </td>
                              <td className='text-center align-middle'>
                                {invoice.invoiceAmount.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                })}{' '}
                                {invoice.currencyCode}
                              </td>
                              <td className='text-center align-middle'>
                                <span className={invoice.remainingAmount > 0 ? 'fw-bold text-success' : 'text-muted'}>
                                  {invoice.remainingAmount.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                  })}{' '}
                                  {invoice.currencyCode}
                                </span>
                              </td>
                              <td className='text-center align-middle'>
                                <div className='d-flex align-items-center justify-content-center'>
                                  <Form.Control
                                    type='number'
                                    value={currentAppliedAmount || ''}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                      const value = parseFloat(e.target.value) || 0;
                                      updateAppliedAmount(invoice.invoiceId, value);
                                    }}
                                    onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
                                      const value = parseFloat(e.target.value) || 0;
                                      updateAppliedAmount(invoice.invoiceId, value);
                                    }}
                                    step='0.01'
                                    min='0'
                                    max={maxAllowed}
                                    className='me-2 text-center fw-bold'
                                    style={{ width: '120px' }}
                                    disabled={invoice.remainingAmount <= 0}
                                  />
                                  {currentAppliedAmount > 0 && (
                                    <Badge bg='success' className='ms-2'>
                                      {((currentAppliedAmount / totalInvoiceAmount) * 100).toFixed(1)}%
                                    </Badge>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={8} className='text-center py-4'>
                            <i className='fas fa-receipt fa-2x text-muted mb-2'></i>
                            <p className='text-muted'>{t('لا توجد فواتير لعرضها')}</p>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className='card-footer d-flex justify-content-between align-items-center'>
                <div className='text-muted small'>
                  {t('عرض')} {displayInvoices.length} {t('من')} {displayInvoices.length} {t('فاتورة')}
                </div>
                <div className='text-theme fw-bold'>
                  {t('المبلغ الإجمالي المطبق')}:{' '}
                  {totalAppliedAmount.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}{' '}
                  {formik.values.currencyCode}
                </div>
              </div>
            </div>
          </Card>
        </div>
      </Loading>
    </div>
  );
};

export default ApDebitMemoApplication;
